export default function formatVideoDuration(duration: number | null) {
  if (!duration) return '00:00';

  return `${Math.floor(duration / 60)
    .toString()
    .padStart(2, '0')}:${Math.floor(duration % 60)
    .toString()
    .padStart(2, '0')}`;
}
